import React from "react";
//#region types
import { AsyncResultListContainerProps } from "models/propTypes/commonPropTypes";
import { SelectionItem } from "models/utilTypes/selectionTypes";
//#endregion
//#region components
import useAPIRequestKeyRef from "../../useAPIRequestKeyRef";
import { AsyncResultList } from "./asyncResultList";
import { useDebouncedCallback } from "use-debounce";
//#endregion
import { ServiceHelper } from "utils/helpers";

const AsyncResultListContainer: React.FC<AsyncResultListContainerProps> = (props) => {
  const [resultList, setResultList] = React.useState<SelectionItem[] | undefined>(undefined);
  const [searchText, setSearchText] = React.useState<string>("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    getResultList("");
  }, [props.parentId, props.getResultList]);

  const { apiRequestKeyRef, updateKey } = useAPIRequestKeyRef();

  const getResultList = (str: string) => {
    const currentKey = updateKey();
    setLoading(true);
    ServiceHelper.withAPIRequestKey(props.getResultList(str), currentKey).then(({ data: result, key: apiKey }) => {
      if (apiKey === apiRequestKeyRef.current) {
        const excludeIds = props.excludeIds ?? [];
        const filteredResult = excludeIds?.length ? result?.filter((r) => !excludeIds.includes(r.id)) : result;
        setResultList(filteredResult);
        setLoading(false);
      }
    });
  };

  const getResultListDebounced = useDebouncedCallback(getResultList, 700);

  const onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const str = e.target.value;
    setSearchText(str);
    getResultListDebounced(str);
  };

  return (
    <AsyncResultList
      {...props}
      items={resultList}
      getItemTemplate={props.getItemTemplate}
      selectedIds={props.selectedIds}
      searchText={searchText}
      searchInputPlaceholder={props.searchInputPlaceholder}
      onSearchTextChange={onSearchTextChange}
      onResultItemSelect={props.onResultItemSelect}
      loading={loading}
    />
  );
};

export default AsyncResultListContainer;
